<div id="divDialogContent" mat-dialog-content [formGroup]="frmMaleShirtKey">
  <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
    <div fxFlex="20">
      <p>
        {{ "module-assignment.maleShirtAndShort.search_by_SKU" | translate }}
      </p>
    </div>
    <div fxFlex="30">
      <mat-form-field floatLabel="never">
        <input
          type="text"
          matInput
          formControlName="filterBySkuCtrl"
          [placeholder]="'module-assignment.hotkeys.sku' | translate"
          (onchange)="onSearchInput($event)"
        />
        <!-- <mat-autocomplete
          autoActiveFirstOption
          #autoSku="matAutocomplete"
          (optionSelected)="onSelectProduct($event)"
          [displayWith]="displaySku"
        >
          <mat-option disabled class="loading" *ngIf="searching || !options.length">
            <div class="image-container">
              <mat-spinner diameter="30"></mat-spinner>
            </div>
          </mat-option>
          <mat-option *ngFor="let option of options" [value]="option">
            {{option.SKU}}
          </mat-option>
        </mat-autocomplete> -->
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
    <div fxFlex="100">
      <mat-card>
        <mat-card-content>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
          >
            <div fxFlex="100">
              <table mat-table #ebasketnameAndNumbersTable [dataSource]="nameAndNumbers" matSort>
                <ng-container matColumnDef="SKU_ID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.maleShirtAndShort.skuID" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.SKU }}</td>
                </ng-container>
                <ng-container matColumnDef="SKU_Name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.maleShirtAndShort.skuName" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- {{element.descriptions[0].value}} -->
                    {{element.descriptions && element.descriptions.length > 0 &&
                    element.descriptions[0].value ? element.descriptions[0].value : ''}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.hotkeys.add_sku" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index;">
                    <!-- <input
                      type="radio"
                      formControlName="sku"
                      [value]="element"
                      [checked]="element.isChecked"
                    /> -->
                    <!-- <button
                      [disabled]="(selected.length === 2) || (selected[0] &&  element.SKU === selected[0].SKU) || (selected[1] && element.SKU === selected[1].SKU)"
                      mat-mini-fab

                      >
                    </button> -->
                    <button
                      style="background-color: transparent;
                                      color: #000000;"
                      [disabled]="(selected.length === 2) || (selected[0] &&  element.SKU === selected[0].SKU) || (selected[1] && element.SKU === selected[1].SKU)"
                      (click)="addSKU(element)"
                      mat-icon-button
                    >
                      <mat-icon>add_circle</mat-icon>
                      <!-- {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}} -->
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="nameAndNumbersColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: nameAndNumbersColumns;"></tr>
              </table>

              <mat-paginator
                [length]="nameAndNumbers.length"
                [pageSize]="pageSizeOptions[0]"
                [pageSizeOptions]="pageSizeOptions"
                [disabled]="nameAndNumbers.length <= pageSizeOptions[0]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-content>
          <div
            fxLayout="row wrap"
            fxLayoutGap="20px grid"
            class="u-margin-top-15 u-margin-bottom-15"
          >
            <div fxFlex="100">
              <table mat-table #ebasketnameAndNumbersTable [dataSource]="selected" matSort>
                <ng-container matColumnDef="SKU_ID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.maleShirtAndShort.skuID" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.SKU }}</td>
                </ng-container>

                <ng-container matColumnDef="SKU_Name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.maleShirtAndShort.skuName" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <!-- {{element.descriptions[0].value}} -->
                    {{element.descriptions && element.descriptions.length > 0 &&
                    element.descriptions[0].value ? element.descriptions[0].value : ''}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="VAT">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "module-assignment.maleShirtAndShort.vat" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <input
                      type="radio"
                      formControlName="sku"
                      [value]="element"
                      [checked]="element.isChecked"
                      (click)="vatableSelected(element)"
                    />
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ "module-assignment.hotkeys.action" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index;">
                    <button
                      mat-icon-button
                      [matTooltip]="'module-assignment.shirtPrint.delete' | translate"
                      matTooltipPosition="above"
                      (click)="removeRow(element)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: selectedColumns;"></tr>
              </table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div fxFlex="100">
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
        <div fxFlex="30">
          <mat-form-field floatLabel="never">
            <input
              type="text"
              matInput
              formControlName="badgeURL"
              [placeholder]="'module-assignment.maleShirtAndShort.badgeURL' | translate"
            />
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
        <div fxFlex="30">
          <mat-form-field floatLabel="never">
            <input
              type="text"
              matInput
              formControlName="logoURL"
              [placeholder]="'module-assignment.maleShirtAndShort.logoURL' | translate"
            />
          </mat-form-field>
        </div>
      </div>
      <div
        *ngIf="selected.length === 2"
        fxLayout="row wrap"
        fxLayoutGap="20px grid"
        class="u-margin-top-15 u-margin-bottom-15"
      >
        <div style="color: red;" fxFlex="30">
          {{ "module-assignment.maleShirtAndShort.max_two_skus_selected" | translate }}
        </div>
      </div>

      <div
        *ngIf="(selected.length === 2) && (!selected[0].isVat && !selected[1].isVat) "
        fxLayout="row wrap"
        fxLayoutGap="20px grid"
        class="u-margin-top-15 u-margin-bottom-15"
      >
        <div style="color: red;" fxFlex="30">
          {{ "module-assignment.maleShirtAndShort.atleast_one_vatable" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
<div id="divDialogAction" mat-dialog-actions class="pull-right">
  <button
    id="btnYes"
    mat-flat-button
    mat-dialog-close="yes"
    cdkFocusInitial
    color="primary"
    [disabled]="frmMaleShirtKey.invalid || isDisabledOk"
    (click)="onSave()"
  >
    {{'module-assignment.hotkeys.ok' | translate}}
  </button>
  <button id="btnNo" mat-flat-button mat-dialog-close="no" color="warn" (click)="onCancel()">
    {{'module-assignment.hotkeys.cancel' | translate}}
  </button>
</div>
